import {
    Card,
    Row,
} from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import { FixedSizeList as List } from "react-window";
import { Radio, RadioGroup } from "rsuite";
import axios from "../utils/axiosConfig";
import Moment from "react-moment";
import SitewideDataContext from "../utils/sitewideContext";
import Preloader from "./preloader";
import {useAuth0} from "@auth0/auth0-react";
Moment.globalFormat = 'YYYY-MM-DD HH:mm:ss';

import "../constants/service_constants";

function SiteHistoryCard({setNewSiteTime}) {
    const { getAccessTokenSilently } = useAuth0();
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(0);
    const {sitewideData, setSitewideData} = useContext(SitewideDataContext);

    let queryParameters = new URLSearchParams(window.location.search);

    const site_id = queryParameters.get("site_id");

    const handleSelect = (value) => {
        setSelected(value);
        setNewSiteTime(value);
    }

    useEffect(() => {
        async function getData() {
            setData([]);
            const accessToken = await getAccessTokenSilently();
            const historyResponse = await axios.get(
                API_ADDRESS + SITE_HISTORY_ENDPOINT + site_id,
                {
                headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            const newData = (historyResponse.data.result || []).map((record) => ({
                start_time: record.start_time.toString(),
            }));
            if (newData.length > 0) {
                setSelected(newData[0].start_time);
            }
            setData(newData);
        }

        getData().finally(() => {
            setSitewideData({
                ...sitewideData,
                overloading: false
            })
        });
    }, [site_id]);

    return (
        <Card className="site-history-card">
            <Card.Header>
                <Card.Title as="h4">History</Card.Title>
            </Card.Header>
            { data.length < 1 ? (
              <Preloader inline={true} overlay={false} />
            ) : (
              <Card.Body>
                  <p className="site-history-card__hint text-muted small mb-2">Select a crawl to view:</p>
                  <div className="site-history-card__list">
                      <RadioGroup
                        name="history"
                        value={selected}
                        onChange={handleSelect}
                      >
                          <List
                            height={Math.min(700, data.length * 56 + 20)}
                            itemCount={data.length}
                            itemSize={56}
                            width="100%"
                            style={{ overflowX: 'hidden' }}
                          >
                              {({ index, style }) => {
                                  const record = data[index];
                                  return (
                                    <div style={style} key={record.start_time}>
                                      <Row>
                                        <div
                                          className="site-history-card__item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleSelect(record.start_time);
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                              e.preventDefault();
                                              handleSelect(record.start_time);
                                            }
                                          }}
                                          role="button"
                                          tabIndex={0}
                                        >
                                          <Radio id={record.start_time} value={record.start_time}>
                                            <Moment unix className="text-muted my-2 site-history-card__item-date">
                                              {record.start_time}
                                            </Moment>
                                          </Radio>
                                        </div>
                                      </Row>
                                    </div>
                                  );
                              }}
                          </List>
                      </RadioGroup>
                  </div>
              </Card.Body>
            )}
            <Card.Footer>
            </Card.Footer>
        </Card>
    );
}

export default SiteHistoryCard;